export enum TicketStatus {
  Open = "open",
  Closed = "closed",
  Reopened = "reopened",
  PendingResponse = "pending_response",
}
